import Vue from 'vue'
import Vuex from 'vuex'

/*
  업무용 로컬 스토어 샘플
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'stats'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        stats: new Map() // key는 컴포넌트 이름, value는 metrics : {'renderTime':0, 'visit':0} 으로 구성
      },
      getters: {
        getState: state => {
          return state.stats
        }
      },
      mutations: {
        // page 통계 관리
        CLEAN (state) {
          state.stats.clear()
        },
        UPDATE (state, metrics) {
          var pages = state.stats
          var savedMetric = pages.get(metrics.compName)

          if (savedMetric === undefined) {
            metrics.visit = 1
          } else {
            metrics.visit = savedMetric.visit + 1
          }

          pages.set(metrics.compName, metrics)
        }
      },
      actions: {
        CLEAN ({commit}) {
          return commit('CLEAN')
        },
        UPDATE ({commit}, payload) {
          return commit('UPDATE', payload)
        }
      }
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/_fdp/core/vuex/system/stats.js